import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { SiteModel } from '@models/sites/sites.store';

import { IconComponent } from '@shared/components/icon/icon.component';
import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  imports: [IconComponent],
  selector: 'aux-site-header',
  standalone: true,
  template: `
    <div class="border-b-[0.5px] border-t-[0.5px] border-aux-gray-dark px-[14px] py-3">
      <div class="flex items-center justify-between">
        <div class="flex space-x-4">
          <aux-icon
            name="ChevronLeft"
            class="cursor-pointer"
            (click)="goToSites()"
            class="mt-[2px]"
          />
          <div>
            <h2 class="text-2xl font-bold">{{ site().name }}</h2>
            <p class="text-xl text-aux-gray-darkest">Site # {{ site().site_no }}</p>
          </div>
        </div>
      </div>

      <div class="pl-4">
        <ng-content />
      </div>
    </div>
  `,
})
export class SiteHeaderComponent {
  router = inject(Router);

  site = input.required<SiteModel>();

  goToSites() {
    void this.router.navigate([
      `${ROUTING_PATH.INVESTIGATOR.INDEX}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.INDEX}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITES.INDEX}`,
    ]);
  }
}
